<template>
  <div class="uk-flex">
    <label v-if="submitted && error" class="uk-form-label"
           :class="{ 'uk-form-danger': submitted && error }">{{message}}</label>
  </div>
</template>

<script>
  export default {
    name: 'input-validation-message',
    props: ['submitted', 'error', 'message']
  }
</script>

<style scoped lang="scss">
  @import '../../../styles/colours';
  @import '../../../styles/breakpoints';


  .uk-form-danger {
    color: $input-warning;
    border-color: $input-warning;
    font-size: 15px;
    font-weight: bold;
  }

  label{
    width: 500px;
  }

  @media screen and (max-width: $breakpoint-xlarge)  {
    .uk-form-danger {
      font-size: 14px;
    }
  }
</style>
